export const extractAPIErrorMessage = (payload: any, fallback = 'Upload failed'): string | null => {
    // 1. Extract the HTTP status code
    const status = payload?.status || payload?.response?.status;

    // 2. SAFEGUARD: If this is a success payload, abort! 
    // This perfectly prevents extracting success messages like "Uploaded files are listed."
    if (status >= 200 && status < 300) {
        return null;
    }

    // 3. Extract the backend JSON data safely
    const backendData = payload?.data || payload?.response?.data || {};
    const targetData = backendData?.results || backendData;

    // 4. Extract strings prioritizing error > message > massage
    let errorMessage = targetData?.error || targetData?.message || targetData?.massage;

    // 5. Handle 'errors' object or array dynamically
    if (!errorMessage && targetData?.errors) {
        if (Array.isArray(targetData.errors)) {
            errorMessage = targetData.errors.join(', ');
        } else if (typeof targetData.errors === 'object') {
            errorMessage = Object.values(targetData.errors).join(', ');
        } else if (typeof targetData.errors === 'string') {
            errorMessage = targetData.errors;
        }
    }

    // 6. Ultimate fallback for generic errors
    return errorMessage || payload?.message || payload?.error || fallback;
};
